import { useMemo } from 'react';
import { EnterpriseSeniority } from 'models/Enterprises';
import { getSortComparator } from 'utils';

export default function useMemberSeniorities(
  memberSeniorities: EnterpriseSeniority[] = [],
) {
  const sortedMemberSeniorities = useMemo(
    () =>
      memberSeniorities.sort((a, b) =>
        getSortComparator(a.name.toLowerCase(), b.name.toLowerCase()),
      ),
    [memberSeniorities],
  );

  const memberSenioritiesOptions = useMemo(
    () =>
      sortedMemberSeniorities.map(({ _id, name }) => ({
        value: _id,
        label: name,
      })),
    [sortedMemberSeniorities],
  );

  return { sortedMemberSeniorities, memberSenioritiesOptions };
}
